import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";
import { msalConfig } from './msalConfig';

let msalInstance: PublicClientApplication | null = null;

const getMsalInstance = async (): Promise<PublicClientApplication> => {
    if (!msalInstance) {
        msalInstance = new PublicClientApplication(msalConfig);
        
        // Initialize MSAL
        await msalInstance.initialize();
        
        // Default to using the first account if available
        msalInstance.addEventCallback((event: EventMessage) => {
            if (event.eventType === EventType.LOGIN_SUCCESS) {
                const result = event.payload as AuthenticationResult;
                if (result?.account) {
                    msalInstance?.setActiveAccount(result.account);
                }
            }
        });

        try {
            // Handle redirect promise
            await msalInstance.handleRedirectPromise();
        } catch (error) {
            console.error("Error handling redirect:", error);
        }
    }
    return msalInstance;
};

// Initialize immediately
const msalPromise = getMsalInstance();

// Export a function that returns the initialized instance
export const getInstance = () => msalPromise; 